import React from 'react';
import PropTypes from 'prop-types';

/**
 * Breadcrumb - A wrapper that renders a standard HTML nav element with Bulma breadcrumb class names
 * 
 * This component accepts the same props as Bloomer Breadcrumb for easy migration
 */
const Breadcrumb = ({
  className,
  style,
  isAlign,
  isSeparator,
  isSize,
  children,
  ...props
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['breadcrumb'];
    
    // Add alignment classes
    if (isAlign) {
      classes.push(`is-${isAlign}`);
    }
    
    // Add separator classes
    if (isSeparator) {
      classes.push(`has-${isSeparator}-separator`);
    }
    
    // Add size classes
    if (isSize) {
      classes.push(`is-${isSize}`);
    }
    
    // Add custom class names
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  return (
    <nav 
      className={getClassNames()} 
      style={style}
      {...props}
    >
      <ul>
        {children}
      </ul>
    </nav>
  );
};

Breadcrumb.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  isAlign: PropTypes.oneOf(['centered', 'right']),
  isSeparator: PropTypes.oneOf(['arrow', 'bullet', 'dot', 'succeeds']),
  isSize: PropTypes.oneOf(['small', 'medium', 'large']),
  children: PropTypes.node
};

Breadcrumb.defaultProps = {
  className: '',
  style: {},
  isAlign: null,
  isSeparator: null,
  isSize: null,
  children: null
};

export default Breadcrumb;
